export default __webpack_public_path__ + "static/media/img_about.be14189f.jpg";